export const isApiFalse = (v) => v === false || v === 0 || v === "0";
